import { Controller } from "@hotwired/stimulus"

export default class BulkCheckController extends Controller {
  static targets = [
    'bulkCheckbox',
    'checkbox',
    'button'
  ]

  connect() {
    if (this.hasBulkCheckboxTarget) {
      this.toggleCheckbox();
    } else {
      for (const button of this.buttonTargets) {
        button.disabled = true;
      }
    }
  }

  toggleCheckbox() {
    if (this.checkboxTargets.length === 0) {
      for (const button of this.buttonTargets) {
        button.disabled = true;
      }
      this.bulkCheckboxTarget.indeterminate = false;
      this.bulkCheckboxTarget.checked = false;
    } else if (this.checkboxTargets.every((checkbox) => checkbox.checked)) {
      for (const button of this.buttonTargets) {
        button.disabled = false;
      }
      this.bulkCheckboxTarget.indeterminate = false;
      this.bulkCheckboxTarget.checked = true;
    } else if (this.checkboxTargets.some((checkbox) => checkbox.checked)) {
      for (const button of this.buttonTargets) {
        button.disabled = false;
      }
      this.bulkCheckboxTarget.indeterminate = true;
      this.bulkCheckboxTarget.checked = false;
    } else {
      for (const button of this.buttonTargets) {
        button.disabled = true;
      }
      this.bulkCheckboxTarget.indeterminate = false;
      this.bulkCheckboxTarget.checked = false;
    }
  }

  toggleBulkCheckbox(e) {
    if (e.target.checked) {
      this.#bulkCheck();
    } else {
      this.#bulkUncheck();
    }

    this.toggleCheckbox();
    this.dispatch('toggle');
  }

  #bulkCheck() {
    for (const checkbox of this.checkboxTargets) {
      if (checkbox.disabled) continue;
      checkbox.checked = true;
    }
  }

  #bulkUncheck() {
    for (const checkbox of this.checkboxTargets) {
      checkbox.checked = false;
    }
  }
}
